/**
 * Size of the button
 */
export var LvButtonSize;
(function (LvButtonSize) {
    /**
     * A smaller version of the button
     */
    LvButtonSize["Small"] = "small";
    /**
     * A larger version of the button
     */
    LvButtonSize["Large"] = "large";
})(LvButtonSize || (LvButtonSize = {}));
/**
 * Supported colors of the button
 */
export var LvButtonColor;
(function (LvButtonColor) {
    LvButtonColor["Primary"] = "primary";
    LvButtonColor["Secondary"] = "secondary";
    LvButtonColor["Light"] = "light";
    LvButtonColor["Dark"] = "dark";
    LvButtonColor["Success"] = "success";
    LvButtonColor["Danger"] = "danger";
})(LvButtonColor || (LvButtonColor = {}));
/**
 * Display of the button
 */
export var LvButtonDisplay;
(function (LvButtonDisplay) {
    /**
     * The button will behave as an inline element.
     */
    LvButtonDisplay["Inline"] = "inline";
    /**
     * The button will behave as a block element.
     */
    LvButtonDisplay["Block"] = "block";
})(LvButtonDisplay || (LvButtonDisplay = {}));
/**
 * Types of borders supported by the button
 */
export var LvButtonBorder;
(function (LvButtonBorder) {
    LvButtonBorder["Solid"] = "solid";
    LvButtonBorder["Dashed"] = "dashed";
})(LvButtonBorder || (LvButtonBorder = {}));
//# sourceMappingURL=model.js.map